// 关于投洽会
const cifi = [
    {
        subName: '投洽会简介',
        pathName: 'IntroPage',
        subLink: '/AboutCifiIntro'
    }, {
        subName: '会标释义',
        pathName: 'LogoPage',
        subLink: '/AboutCifiLogo'
    }, {
        subName: '组织机构',
        pathName: 'ORGPage',
        subLink: '/AboutCifiORG'
    }, {
        subName: '主题、形式',
        pathName: 'ThemePage',
        subLink: 'AboutCifiTheme'
    }, {
        subName: '功能',
        pathName: 'FuncPage',
        subLink: 'AboutCifiFunc'
    }, {
        subName: '组委会领导',
        pathName: 'LeaderPage',
        subLink: 'AboutCifiLeader'
    }, {
        subName: '领导寄语',
        pathName: 'MsgPage',
        subLink: 'AboutCifiMsg'
    }, {
        subName: '五大洲的声音',
        pathName: 'VoicePage',
        subLink: 'AboutCifiVoice'
    }, {
        subName: '历届回望',
        pathName: 'HisCifiPage',
        subLink: 'AboutCifiHisCifi'
    }, {
        subName: '历届赞助机构',
        pathName: 'SponsorPage',
        subLink: 'AboutCifiSponsor'
    }, {
        subName: '迷人的厦门',
        pathName: 'XMPage',
        subLink: 'AboutCifiXM'
    }
]
// 新闻中心
const news = [
    {
        subName: '最新动态',
        pathName: 'LatestPage',
        subLink: 'NewsCenterLatest'
    }, {
        subName: '图片新闻',
        pathName: 'PicPage',
        subLink: 'NewsCenterPic'
    }, {
        subName: '公告板',
        pathName: 'BoardPage',
        subLink: 'NewsCenterBoard'
    }, {
        subName: '新闻中心职责',
        pathName: 'ORGNewsPage',
        subLink: 'NewsCenterORG'
    }, {
        subName: '新闻素材下载',
        pathName: 'BoardPage',
        subLink: 'NewsCenterBoard'
    }, {
        subName: '媒体报道',
        pathName: 'BoardPage',
        subLink: 'NewsCenterBoard'
    }, {
        subName: '厦门动态',
        pathName: 'LatestPage',
        subLink: 'NewsCenterLatest'
    }, {
        subName: '展商风采',
        pathName: 'LatestPage',
        subLink: 'NewsCenterLatest'
    }, {
        subName: '志愿者风采',
        pathName: 'LatestPage',
        subLink: 'NewsCenterLatest'
    }, {
        subName: '联络方式',
        pathName: 'contactN',
        subLink: 'NewsCenterContact'
    }
]
// 参会指南
const participation = [
    {
        subName: '邀请函',
        pathName: 'PdfPPage',
        subLink: 'ParticipationPdf'
    }, {
        subName: '票证办理程序',
        pathName: 'TicketPage',
        subLink: 'ParticipationTicket'
    }, {
        subName: '参会问答',
        pathName: 'answerPage',
        subLink: 'ParticipationAnswer'
    }, {
        subName: '在线报名',
        pathName: '',
        subLink: 'HelloWorld'
    }, {
        subName: '记者参会指南',
        pathName: 'ReporterPage',
        subLink: 'ParticipationReporter'
    }
]
// 展商指南
const exhibitor = [
    {
        subName: '参展收获',
        pathName: 'ExhibitorPage',
        subLink: 'ExhibitorDetail'
    }, {
        subName: '展馆规划',
        pathName: 'planPage',
        subLink: 'ExhibitorPlan'
    }, {
        subName: '展览日程安排',
        pathName: 'schedulePage',
        subLink: 'ExhibitorSchedule'
    }, {
        subName: '展位价格',
        pathName: 'pricePage',
        subLink: 'ExhibitorPrice'
    }, {
        subName: '参展程序',
        pathName: 'programPage',
        subLink: 'ExhibitorProgram'
    }, {
        subName: '网上报名参展',
        pathName: 'BoothPage',
        subLink: 'ExhibitorBooth'
    }, {
        subName: '展位申请指引',
        pathName: 'guidePage',
        subLink: 'ExhibitorGuide'
    }, {
        subName: '推荐布展商',
        pathName: 'recommendPage',
        subLink: 'ExhibitorRecommend'
    },
    {
        subName: '报馆系统',
        pathName: 'baoguan',
        subLink: 'baoguan'
    }
]
// 论坛研讨会
const forum = [
    {
        subName: '会议论坛',
        pathName: 'CloudConference',
        subLink: 'HelloWorld'
    },
    // {
    //     subName: '平行论坛',
    //     pathName: 'Forum',
    //     subLink: 'ForumProcess'
    // },
    // {
    //     subName: '专题论坛',
    //     pathName: 'Forum',
    //     subLink: 'ForumProcess'
    // },
    {
        subName: '参会流程',
        pathName: 'processFPage',
        subLink: 'ForumProcess'
    }, {
        subName: '服务指南',
        pathName: 'serviceFPage',
        subLink: 'ForumService'
    },
    // {
    // subName: '会议动态',
    // pathName: 'CloudConference',
    // subLink: 'ForumDataList'
    // },
    // {
    //     subName: '国际投资论坛',
    //     pathName: '',
    //     subLink: 'HelloWorld'
    // },
    // {
    //     subName: '嘉宾风采',
    //     pathName: 'guestFPage',
    //     subLink: 'ForumGuest'
    // },
    {
        subName: '联络会议组',
        pathName: 'contactFPage',
        subLink: 'ForumContact'
    }
]
// 项目对接
const project = [
    {
        subName: '简介',
        pathName: 'infoPPage',
        subLink: 'ProjectInfo'
    }, {
        subName: '项目查询',
        pathName: 'proSearchPage',
        subLink: 'ProjectSearch'
    }, {
        subName: '投资商查询',
        pathName: 'proSearchPage',
        subLink: 'ProjectSearch'
    }, {
        subName: '投资商报名',
        pathName: '',
        subLink: 'HelloWorld'
    }, {
        subName: '项目对接问答',
        pathName: 'proAnswerPage',
        subLink: 'ProjectAnswer'
    }
]
// 资料中心
const material = [
    {
        subName: '资料下载',
        pathName: 'FilePage',
        subLink: 'MaterialFile'
    }, {
        subName: '视频点播',
        pathName: 'VideoPage',
        subLink: 'MaterialVideo'
    }, {
        subName: '历届回顾',
        pathName: 'HisMPage',
        subLink: 'MaterialHisM'
    }, {
        subName: '历届团组',
        pathName: 'pdfMPage',
        subLink: 'MaterialSeaGroup'
    }
]
// 菜单
const menu = [
    {
        name: '首页',
        link: '/index',
        subMenu: []
    }, {
        name: '关于投洽会',
        link: '/AboutCifi',
        subMenu: cifi
    }, {
        name: '国际投资论坛',
        link: '/CloudConference',
        // link: 'https://www.chinafair.org.cn/iiforum/#/',
        // linkUrl:"https://www.chinafair.org.cn/iiforum/#/",
        subMenu: forum
    }, {
        name: '新闻中心',
        link: '/NewsCenter',
        subMenu: news
    }, {
        name: '参会指南',
        link: '/Participation',
        subMenu: participation
    }, {
        name: '展商指南',
        link: '/Exhibitor',
        subMenu: exhibitor
    }, {
        name: '项目对接',
        link: '/Project',
        subMenu: project
    }, {
        name: '资料中心',
        link: '/Material',
        subMenu: material
    },
    // {
    //     name: "云上投洽会",
    //     link: "/CloudFairIndex",
    //     link2: "/CloudFairIndex",
    //     subMenu: []
    // }
]
export default {
    cifi,
    news,
    menu,
    participation,
    exhibitor,
    forum,
    project,
    material,
}


// WEBPACK FOOTER //
// ./src/util/globalmenu.js